<template>
    <SearchAutocomplete
        ref="autocomplete"
        v-model="selected"
        :set-value="setValue"
        :api-endpoint="searchQuery => `/api/course-codes?search=${searchQuery}&per_page=100`"
        :label="label"
        field="name"
        :initial-data="initialData"
        open-on-focus
        clearable
        :placeholder="placeholder"
        filter-type="Course Codes"
        url-params="course_code"
        :include-icon="includeIcon ? 'filter' : ''"
        @clear="$emit('update:modelValue', null)"
        @selected="courseCode => $emit('update:modelValue', courseCode)"
        @esc="$emit('update:modelValue', null)"
    >
        <template #item="{ itemData }">
            {{ itemData.option.name }}
        </template>
    </SearchAutocomplete>
</template>

<script>
import first from 'lodash/first.js';

import SearchAutocomplete from '@/components/autocomplete/Autocomplete.vue';
import axios from '@/plugins/axios.js';

export default {
    name: 'CourseCodeSearch',

    components: { SearchAutocomplete },

    props: {
        course: {
            type: Object,
            required: false,
            default: null,
        },

        label: {
            type: String,
            required: false,
            default: '',
        },

        placeholder: {
            type: String,
            required: false,
            default: 'Type a course code...',
        },

        modelValue: {
            type: [Object, String],
            required: false,
            default: () => ({}),
        },

        initialData: {
            type: Array,
            required: false,
            default: () => [],
        },

        setValue: {
            type: String,
            required: false,
            default: null,
        },

        autofill: {
            type: Boolean,
            required: false,
            default: true,
        },

        presetId: {
            type: Number,
            required: false,
            default: null,
        },

        includeIcon: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            selected: null,
        };
    },

    async created() {
        if (this.presetId) {
            await this.setInitialData();
        }
    },

    emits: ['update:modelValue'],

    mounted() {
        if (this.course && this.autofill) {
            this.$refs.autocomplete.$refs.autocomplete.setSelected(this.course.course_codes[0]);
        }
    },

    methods: {
        async setInitialData() {
            try {
                const { data } = await axios.get(`/api/course-codes/${this.presetId}`);
                this.selected = first(data.data);

                this.$emit('update:modelValue', first(data.data));
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>
